import BaseComponent from '../base-component/base-component'

const postLink = function (path, options) {
  options = options || {}

  const method = options['method'] || 'post'
  const params = options['parameters'] || {}

  const form = document.createElement('form')

  form.setAttribute('method', method)
  form.setAttribute('action', path)

  for (let key in params) {
    let hiddenField = document.createElement('input')

    hiddenField.setAttribute('type', 'hidden')
    hiddenField.setAttribute('name', key)
    hiddenField.setAttribute('value', params[key])

    form.appendChild(hiddenField)
  }

  document.body.appendChild(form)

  form.submit()

  document.body.removeChild(form)
}

class CustomerAddresses extends BaseComponent {
  deleteButtons: HTMLElement[]

  constructor() {
    super()

    this.deleteButtons = [
      ...this.querySelectorAll('[data-addresses-delete-button]'),
    ] as HTMLElement[]
  }

  connectedCallback(): void {
    this.deleteButtons.forEach(element => {
      element.addEventListener('click', this.handleDeleteButtonClick)
    })
  }

  disconnectedCallback(): void {
    this.deleteButtons.forEach(element => {
      element.removeEventListener('click', this.handleDeleteButtonClick)
    })
  }

  handleDeleteButtonClick = ({ currentTarget }): void => {
    const confirmMessage = currentTarget.getAttribute('data-confirm-message')

    const isConfirm = confirm(confirmMessage)

    if (isConfirm) {
      postLink(currentTarget.dataset.target, {
        parameters: { _method: 'delete' },
      })
    }
  }
}

export default CustomerAddresses
